import { useEffect, Component } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Statement from "@/components/Statement";
import Capabilities from "@/components/Capabilities";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminApp from "@/components/AdminApp";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-ink text-bone flex items-center justify-center p-8">
          <p className="font-display text-3xl uppercase tracking-[0.02em]">
            Something went wrong. Please refresh.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const isAdminRoute =
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/admin");

function LandingPage() {
  useEffect(() => {
    let lenis;
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (!reduced) {
      import("lenis").then(({ default: Lenis }) => {
        lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        const raf = (time) => {
          lenis.raf(time);
          requestAnimationFrame(raf);
        };
        requestAnimationFrame(raf);
      });
    }
    return () => {
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative bg-ink font-body text-bone">
      <div
        aria-hidden
        className="grain pointer-events-none fixed inset-0 z-[60] opacity-[0.05]"
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Statement />
        <Capabilities />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      {isAdminRoute ? (
        <div className="min-h-screen bg-ink font-body text-bone">
          <AdminApp />
        </div>
      ) : (
        <>
          <LandingPage />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#292728",
                color: "#E0E0DC",
                border: "1px solid rgba(224,224,220,0.15)",
                borderRadius: "0",
              },
            }}
          />
        </>
      )}
    </ErrorBoundary>
  );
}

export default App;
